import { publicRuntimeConfig } from "../config/publicRuntimeConfig";

export type ImageRef = {
  hash: string;
  filename: string;
};

// Cross-origin from staff-ui, so the asset URL must be absolute.
export const FILES_BASE_URL = publicRuntimeConfig.filesBaseUrl;

function fileExtension(filename: string): string {
  const dot = filename.lastIndexOf(".");
  return dot >= 0 ? filename.slice(dot + 1).toLowerCase() : "bin";
}

function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

// The slug is cosmetic — Cloudflare/legal500-bff key only on the hash + ext.
export function buildFilesUrl(ref: ImageRef | null | undefined, slug?: string): string | null {
  if (!ref?.hash || !ref.filename) return null;
  const ext = fileExtension(ref.filename);
  const base = ref.filename.replace(/\.[^.]+$/, "");
  const seo = slugify(slug || base) || "file";
  return `${FILES_BASE_URL}/assets/dynamic/${ref.hash}/${seo}.${ext}`;
}
